'use strict';

var _ = require('lodash');

var OR = function(fn1, fn2) {
    var or = function(info) {
        var result = fn1(info);
        if (result) {
            or.storeName = 'or.a:' + fn1.storeName;
            return result;
        }
        else {
            or.storeName = 'or.b:' + fn2.storeName;
            return fn2(info);
        }
    };
    return or;
};

var pick = function(store, customPicker) {
    var picker = store[customPicker || 'pick'];
    var binded = _.bind(picker, store);
    binded.attempts = 0;
    binded.storeName = store.name;
    return binded;
};

var repeat = function(fn, times) {
    var repetition = [];
    while (times--) repetition.push(fn);
    return repetition;
};

module.exports = {
    OR: OR,
    pick: pick,
    repeat: repeat
};
